import { render, staticRenderFns } from "./indexHeader.vue?vue&type=template&id=1a3548ca&scoped=true"
import script from "./indexHeader.vue?vue&type=script&lang=js"
export * from "./indexHeader.vue?vue&type=script&lang=js"
import style0 from "./indexHeader.vue?vue&type=style&index=0&id=1a3548ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3548ca",
  null
  
)

export default component.exports